import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import { RoomBrandActions } from "../actions";

export const ROOM_BRAND_FEATURE_KEY = "roomBrand";

export interface RoomBrandState extends EntityState<Record<string, never>> {
  isLoading: boolean;
}

export const roomBrandAdapter: EntityAdapter<Record<string, never>> =
  createEntityAdapter();

const initialState: RoomBrandState = roomBrandAdapter.getInitialState({
  isLoading: false
});

const reducer = createReducer(
  initialState,
  on(RoomBrandActions.roomBrandCreate, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandActions.roomBrandCreateFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandActions.roomBrandCreateSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandActions.roomBrandDelete, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandActions.roomBrandDeleteFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandActions.roomBrandDeleteSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandActions.roomBrandUpdate, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandActions.roomBrandUpdateFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandActions.roomBrandUpdateSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandActions.roomBrandUse, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandActions.roomBrandUseFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandActions.roomBrandUseSuccess, (state) => ({
    ...state,
    isLoading: false
  }))
);

export function roomBrandReducer(
  state: RoomBrandState | undefined,
  action: Action
) {
  return reducer(state, action);
}
